import * as React from 'react'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import BlockIcon from '@mui/icons-material/Block'
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined'

const getIcon = (record: string): JSX.Element => {
  switch (record) {
    case 'blocked':
      return <BlockIcon color="error" />
    case 'active':
      return <CheckCircleOutlineIcon color="success" />
    case 'admin':
      return <PersonOutlineOutlinedIcon color="textSecondary" />
    default:
      return <TimerOutlinedIcon color="warning" />
  }
}

export default getIcon
